import { useEffect, useState } from 'react'
import { GiHamburgerMenu } from 'react-icons/gi'
import { FiChevronDown, FiSave, FiShield, FiUser } from 'react-icons/fi'
import { api } from '../../../api/api'
import { Toast } from '../../../utils/Toast'
import _ from 'lodash'

const translate = {
  "update": "Atualizar",
  "cancelar_pedido": "Cacelar pedido",
  "create_pedido_balcao": "Criar pedido de balcão",
  "view": "Visualizar",
  "create": "Criar",
  "delete": "Deletar",
  "emissao": "Emitir nota",
  "open_safe": "Abrir caixa",
  "close_safe": "Fechar caixa",
  "update_status": "Alterar etapa",
  "posicao_estabelecimento": "Selecionar posição",
  'criar_mesa': "Criar mesa",
  'adicionar_comanda': "Adicionar comanda",
  'deletar_comanda': "Remover comanda",
  'transferir_comanda': "Transferir comanda de mesa",
  'abrir_mesa': "Abrir mesa",
  'fechar_mesa': "Fechar mesa",
  'alterar_codigo_comanda': "Alterar código de comanda"
}

const DEFAULT_PERMISSION = [
  {
    title: "Cardápio",
    page: 'cardapio',
    permissions: ['view', 'update'],
    selected: []
  },
  {
    title: "Pedidos",
    page: 'pedidos',
    permissions: ['update', 'cancelar_pedido', 'create_pedido_balcao'],
    selected: []
  },
  {
    title: "KDS / Cozinha",
    page: 'kds',
    permissions: ['view', 'update_status'],
    selected: []
  },
  {
    title: "Produtos",
    page: 'produtos',
    permissions: ['view', 'create', 'update', 'delete'],
    selected: []
  },
  {
    title: "Estoque",
    page: 'estoque',
    permissions: ['view', 'create', 'update'],
    selected: []
  },
  {
    title: "Fiscal",
    page: 'fiscal',
    permissions: ['view', 'emissao', 'cancelar'],
    selected: []
  },
  {
    title: "Clientes",
    page: 'clientes',
    permissions: ['view', 'create', 'update', 'delete'],
    selected: []
  },
  {
    title: "Entregadores",
    page: 'entregadores',
    permissions: ['view', 'create', 'update', 'delete'],
    selected: []
  },
  {
    title: "Cupons",
    page: 'cupons',
    permissions: ['view', 'create', 'update', 'delete'],
    selected: []
  },
  {
    title: "Campanhas",
    page: 'campanha',
    permissions: ['view'],
    selected: []
  },
  {
    title: "Método de entrega",
    page: 'metodo_entrega',
    permissions: ['view', 'create', 'update', 'delete'],
    selected: []
  },
  {
    title: "Avaliações",
    page: 'avaliacao',
    permissions: ['view'],
    selected: []
  },
  {
    title: "Relatório",
    page: 'relatorio',
    permissions: ['view'],
    selected: []
  },
  {
    title: "Formas de Pagamento",
    page: 'forma_pagamento',
    permissions: ['view'],
    selected: []
  },
  {
    title: "Integrações",
    page: 'integracao',
    permissions: ['view'],
    selected: []
  },
  {
    title: "Caixa",
    page: 'caixa',
    permissions: ['view', 'create', 'open_safe', 'close_safe'],
    selected: []
  },
  {
    title: "Setor",
    page: 'setor',
    permissions: ['view', 'create', 'update'],
    selected: []
  },
  {
    title: "Usuário",
    page: 'user',
    permissions: ['view'],
    selected: []
  },
  {
    title: "Configurações",
    page: 'configuracoes',
    permissions: ['posicao_estabelecimento', 'view'],
    selected: []
  },
  {
    title: "Mesas",
    page: 'mesas',
    permissions: ['criar_mesa', 'adicionar_comanda', 'deletar_comanda', 'transferir_comanda', 'abrir_mesa', 'fechar_mesa', 'alterar_codigo_comanda'],
    selected: []
  },
]

function Item({ title, payload, change }) {
  return (
    <article className="permission-item">
      <button type="button" className="permission-item-header" id={`click-${payload.page}`} data-bs-toggle="collapse" data-bs-target={`#${payload.page}`} aria-controls={payload.page}>
        <span><GiHamburgerMenu /></span><strong>{title}</strong><small>{payload.selected?.length || 0} selecionadas</small><FiChevronDown />
      </button>
      <div className="collapse" id={payload.page}>
          <div className="permission-options">
            {_.orderBy(payload?.permissions, 'asc').map(e => {
              return <button type="button"
                key={e}
                className={payload?.selected?.includes(e) ? 'selected' : ''}
                onClick={() => {
                  if (payload?.selected?.includes(e)) {
                    change({ ...payload, selected: payload.selected.filter(select => select !== e) })
                  } else {
                    change({ ...payload, selected: [...new Set([...payload?.selected ?? [], e])] })
                  }
                }}
              >{translate[e] || e}</button>
            })}
          </div>
      </div>
    </article>
  )
}

const DEFAULT_USER_INFO = {
  id: null,
  email: '',
  name: '',
  password: '',
  typeUser: ['admin'],
  status: false,
  isPrint: true,
  canCloseOrder: false
}

export function PermissionsModal({ userId, reload, clearSelectUser }) {
  const [userInfo, setUserInfo] = useState(DEFAULT_USER_INFO)
  const [permissions, setPermissions] = useState(() => DEFAULT_PERMISSION.map(permission => ({ ...permission, selected: [] })))

  function resetModal() {
    setUserInfo({ ...DEFAULT_USER_INFO, typeUser: [...DEFAULT_USER_INFO.typeUser] })
    setPermissions(DEFAULT_PERMISSION.map(permission => ({ ...permission, selected: [] })))
    clearSelectUser()
  }

  function change(newValue) {
    setPermissions(state => {
      return state.map(e => {
        if (e.title === newValue.title) {
          return newValue
        }

        return e
      })
    })
  }

  async function saveOrUpdated() {
    let id = userInfo?.id
    if (userInfo.id) {
      await api.put('/users/' + userInfo.id, userInfo)
      Toast.success('Registro atualizado com sucesso')
    } else {
      const response = await api.post('/users', userInfo)
      id = response.data.id
      Toast.success('Registro salva com sucesso')
    }

    const body = permissions.map(value => { return { [value.page]: value.selected } }).reduce((result, item) => {
      const key = Object.keys(item)[0];
      const value = item[key];

      result[key] = _.orderBy(value, 'asc');
      return result;
    }, {});

    await api.post('/users/permissions/user', {
      userId: id,
      ...body
    })

    await reload()
  }

  async function findInfo(id) {
    const response = await api.get('/users/list-info/' + id)
    const userInfoData = response.data.user
    const permissionsData = DEFAULT_PERMISSION.map((value) => ({
      ...value,
      selected: response?.data?.permission?.[value.page] || []
    }))

    setPermissions(permissionsData)
    setUserInfo({
      email: userInfoData.email,
      name: userInfoData.name,
      status: userInfoData.status,
      password: '',
      typeUser: [userInfoData.typeUser],
      id: userInfoData.id,
      isPrint: userInfoData.isPrint,
      canCloseOrder: !!userInfoData.canCloseOrder
    })
  }

  useEffect(() => {
    (async () => {
      if (userId) {
        await findInfo(userId)
        new window.bootstrap.Modal(document.getElementById('modalPermissions'), {}).toggle()
      } else {
        setUserInfo({ ...DEFAULT_USER_INFO, typeUser: [...DEFAULT_USER_INFO.typeUser] })
        setPermissions(DEFAULT_PERMISSION.map(permission => ({ ...permission, selected: [] })))
      }
    })()
  }, [userId])

  return (
    <div className="modal fade admin-form-modal" id="modalPermissions" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="modalPermissionsLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header permissions-modal-header">
            <div><span><FiUser /></span><div><h5 id="modalPermissionsLabel">{userInfo.id ? 'Editar usuário' : 'Novo usuário'}</h5><p>Dados de acesso e permissões da equipe</p></div></div>
            <button onClick={resetModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <section className="permissions-user-section">
              <div className="permissions-section-title"><FiUser /><div><h6>Informações do usuário</h6><p>Dados utilizados para acessar o sistema</p></div></div>
            <div className='permissions-user-form'>
              <label><span>Nome</span><input value={userInfo.name} onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })} type="text" /></label>
              <label><span>E-mail</span><input value={userInfo.email} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} type="email" /></label>
              <label><span>Senha</span><input type="password" value={userInfo.password} onChange={(e) => setUserInfo({ ...userInfo, password: e.target.value })} placeholder={userInfo.id ? 'Deixe vazio para manter' : ''} /></label>
              <label><span>Tipo de usuário</span><select onChange={(e) => setUserInfo({ ...userInfo, typeUser: [e.target.value] })} value={userInfo.typeUser[0]}>
                  <option value="admin">Administrador</option>
                  <option value="sub_admin">Gerente</option>
                  <option value="garcom">Garçom</option>
                  <option value="user">Usuário</option>
                </select></label>
              <label className="permission-setting-toggle"><span>Usuário ativo</span><span className="admin-toggle"><input checked={userInfo.status} onChange={(e) => setUserInfo({ ...userInfo, status: e.target.checked })} type="checkbox" role="switch" /><i /></span></label>
              <label className="permission-setting-toggle"><span>Impressão direta</span><span className="admin-toggle"><input checked={userInfo.isPrint} onChange={(e) => setUserInfo({ ...userInfo, isPrint: e.target.checked })} type="checkbox" role="switch" /><i /></span></label>
              {userInfo.typeUser.includes('garcom') && (
                <label className="permission-setting-toggle"><span>Pode fechar e receber pedidos no app</span><span className="admin-toggle"><input checked={userInfo.canCloseOrder} onChange={(e) => setUserInfo({ ...userInfo, canCloseOrder: e.target.checked })} type="checkbox" role="switch" /><i /></span></label>
              )}
            </div>
            </section>
            {userInfo.typeUser.includes('user') && (
              <section className="permissions-access-section">
                <div className="permissions-section-title"><FiShield /><div><h6>Permissões de acesso</h6><p>Selecione o que este usuário pode visualizar e alterar</p></div></div>
                <div className="permissions-list">
                  {permissions?.map(value => {
                    return (<Item key={value.title} title={value.title} payload={value} change={change} />)
                  })}
                </div>
              </section>
            )}
          </div>
          <div className="modal-footer permissions-modal-footer"><button type="button" className="admin-secondary-button" data-bs-dismiss="modal" onClick={resetModal}>Cancelar</button><button className="admin-primary-button" onClick={saveOrUpdated}><FiSave /> Salvar usuário</button></div>
        </div>
      </div>
    </div>
  )
}
